export const viewTitle = "Поступившие документы";
export const viewUniqKey = "receiptFromOikView";
